import TopBar from './components/TopBar';
import Hero from './components/Hero';
import HotRank from './components/HotRank';
import FeaturedGrid from './components/FeaturedGrid';
import CollectionZones from './components/CollectionZones';
import TimelineDir from './components/TimelineDir';
import TopicZones from './components/TopicZones';
import FaqBlock from './components/FaqBlock';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#f8f4ec] text-stone-900">
      <TopBar />
      <main>
        <Hero />
        <HotRank />
        <FeaturedGrid />
        <CollectionZones />
        <TimelineDir />
        <TopicZones />
        <FaqBlock />
      </main>
      <Footer />
    </div>
  );
}